import React from 'react';
import Form from 'react-bootstrap/Form';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Button from 'react-bootstrap/Button';
import RichText from '../controls/RichText';
import { useForceUpdate, numberToLetter } from '../util';
import TaskSlider from 'interactive/dist/TaskSlider/TaskSlider';
import { Content } from '../DataStructures';
import { TabContextReporter } from '../TabContext';
import { FormValidityReporter } from '../FormValidity';
import { contentIsEmpty } from './TaskMultiChoice';
export default function TaskSelect(props) {
  const forceUpdate = useForceUpdate();
  const dataProps = props.data.props;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(TabContextReporter, {
    index: "0",
    title: "1. Initial Information"
  }, /*#__PURE__*/React.createElement(Form, null, /*#__PURE__*/React.createElement(Form.Group, null, /*#__PURE__*/React.createElement(Form.Label, null, /*#__PURE__*/React.createElement("b", null, "Response Prefix:"), " ", /*#__PURE__*/React.createElement("i", null, "This text goes before the dropdown.")), /*#__PURE__*/React.createElement(RichText, {
    inlineOnly: dataProps.inline,
    value: dataProps.label,
    onChange: v => {
      dataProps.label = v;
      forceUpdate();
      props.onChanged();
      props.triggerStateUpdate();
    }
  })), /*#__PURE__*/React.createElement(Form.Group, null, /*#__PURE__*/React.createElement(Form.Label, null, /*#__PURE__*/React.createElement("b", null, "Response Postfix:"), " ", /*#__PURE__*/React.createElement("i", null, "This text goes after the dropdown.")), /*#__PURE__*/React.createElement(RichText, {
    inlineOnly: dataProps.inline,
    value: dataProps.description,
    onChange: v => {
      dataProps.description = v;
      forceUpdate();
      props.onChanged();
      props.triggerStateUpdate();
    }
  })), /*#__PURE__*/React.createElement(Form.Group, null, /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
    xs: "auto"
  }, /*#__PURE__*/React.createElement(Form.Check, {
    name: "select-check",
    type: "checkbox",
    checked: dataProps.inline,
    onChange: e => {
      dataProps.inline = e.target.checked;
      forceUpdate();
      props.onChanged();
      props.triggerStateUpdate();
    }
  })), /*#__PURE__*/React.createElement(Col, null, /*#__PURE__*/React.createElement(Form.Label, null, /*#__PURE__*/React.createElement("b", null, "Inline:"), " ", /*#__PURE__*/React.createElement("i", null, "Display the dropdown on the same line as the label and description."))))), /*#__PURE__*/React.createElement(Form.Group, null, /*#__PURE__*/React.createElement(Form.Label, null, /*#__PURE__*/React.createElement("b", null, "Dropdown Width:")), /*#__PURE__*/React.createElement(TaskSlider, {
    handleChange: value => {
      dataProps.buttonWidth = `${value}px`;
      forceUpdate();
      props.onChanged();
    },
    start: parseInt(dataProps.buttonWidth),
    min: 50,
    max: 300,
    step: 1,
    tooltip: "auto"
  })))), /*#__PURE__*/React.createElement(TabContextReporter, {
    index: "1",
    title: "2. Response Details"
  }, /*#__PURE__*/React.createElement(Form, null, /*#__PURE__*/React.createElement(Form.Group, null, /*#__PURE__*/React.createElement(Form.Label, null, /*#__PURE__*/React.createElement("b", null, "Question Response:"), " ", /*#__PURE__*/React.createElement("i", null, "Select the correct option.")), dataProps.options.map((choice, key) => {
    return /*#__PURE__*/React.createElement(Form.Check, {
      id: "choice-" + key,
      name: "options"
    }, /*#__PURE__*/React.createElement(Form.Row, {
      className: "align-items-center mb-2"
    }, /*#__PURE__*/React.createElement(Form.Check.Input, {
      type: "radio",
      checked: dataProps.correct === key,
      onChange: e => {
        if (e.target.checked) {
          dataProps.correct = key;
          props.triggerStateUpdate();
          forceUpdate();
          props.onChanged();
        }
      }
    }), /*#__PURE__*/React.createElement(Form.Check.Label, {
      width: "100%"
    }, numberToLetter(key), ":\xA0"), /*#__PURE__*/React.createElement(Col, null, /*#__PURE__*/React.createElement(RichText, {
      value: dataProps.options[key],
      inlineOnly: true,
      onChange: v => {
        dataProps.options[key] = v;
        forceUpdate();
        props.onChanged();
      }
    }), /*#__PURE__*/React.createElement(FormValidityReporter, {
      valid: !contentIsEmpty(dataProps.options[key])
    }, "Question Response is empty.")), /*#__PURE__*/React.createElement(Col, {
      xs: "auto"
    }, dataProps.options.length > 1 && /*#__PURE__*/React.createElement(Button, {
      variant: "outline-danger",
      title: "Remove choice",
      onClick: () => {
        dataProps.options.splice(key, 1);
        props.triggerStateUpdate();
        props.onChanged();
      }
    }, /*#__PURE__*/React.createElement("i", {
      className: "bi bi-trash"
    })))));
  }), /*#__PURE__*/React.createElement(Button, {
    variant: "success",
    title: "Add new choice",
    onClick: () => {
      dataProps.options.push(new Content());
      props.triggerStateUpdate();
      props.onChanged();
    }
  }, /*#__PURE__*/React.createElement("i", {
    className: "bi bi-plus-lg"
  }))))));
}